import React from 'react';
import { Outlet } from 'react-router-dom';

const RetailerOrderLayout: React.FC = () => {
  return <Outlet />;
};

export default RetailerOrderLayout;
